export const SET_ANONYMOUS = 'user/SET_ANONYMOUS';
export const LOG_IN = 'user/LOG_IN';
export const LOG_OUT = 'user/LOG_OUT';

export const setAnonymous = () => ({
  type: SET_ANONYMOUS
});
export const logIn = () => ({
  type: LOG_IN
});
export const logOut = () => ({
  type: LOG_OUT
});
